import { render, staticRenderFns } from "./DoctorsListItem.vue?vue&type=template&id=4d21ab5b&scoped=true&"
import script from "./DoctorsListItem.vue?vue&type=script&lang=js&"
export * from "./DoctorsListItem.vue?vue&type=script&lang=js&"
import style0 from "./DoctorsListItem.vue?vue&type=style&index=0&id=4d21ab5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d21ab5b",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox})
